import React from 'react';
import { TableCell, TableHead, TableRow } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

export interface HeaderType {
  id: string;
  title: string;
  width: number | string;
  height?: number | string;
}

interface HeaderColumns {
  columns: Array<HeaderType>;
}

/* ************ Style ************ */
const useStyles = makeStyles()(() => ({
  head: {
    backgroundColor: '#CFCFCF',
  },
}));

const MachineStationTableHead: React.FC<React.PropsWithChildren<HeaderColumns>> = React.memo(({ columns }) => {
  const { classes } = useStyles();

  return (
    <TableHead>
      <TableRow>
        {columns.map((column) => (
          <TableCell
            key={`machine_list_table_head_key_${column.id}`}
            style={{ width: column.width, height: column.height ?? '', whiteSpace: 'pre-line' }}
            className={classes.head}>
            {column.title}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
});

export default MachineStationTableHead;
